import { Center, Group, Text, SegmentedControl, Stack, useMantineTheme } from '@mantine/core';
import { useNavigate, useParams } from 'react-router-dom';
import { IconStar, IconArchive, IconSettings } from '@tabler/icons-react';

import { useCallback } from 'react';

import Resources from '../Resources/Resources';
import Proposals from '../Proposals/Proposals';
import Settings from '../Settings/Settings';
import classes from './Dashboard.module.css';
import useEnsisQuery from '../../hooks/useEnsisQuery';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { colors } = useMantineTheme();
  const { dashboardSection, organization } = useParams();
  const handleSegmentChange = useCallback((value: string) => {
    navigate(`/org/${organization}/${value.toLowerCase()}/`);
  }, []);

  const { data: meData } = useEnsisQuery('/app/users/me');

  const pageData = [
    {
      value: 'proposals',
      label: (
        <Center style={{ gap: 8 }}>
          <IconStar size={20} />
          <span>Proposals</span>
        </Center>),
      component: <Proposals />
    },
    {
      value: 'resources',
      label: (
        <Center style={{ gap: 8 }}>
          <IconArchive size={20} />
          <span>Resources</span>
        </Center>
      ),
      component: <Resources />
    },
    {
      value: 'settings',
      label: (
        <Center style={{ gap: 8 }}>
          <IconSettings size={20} />
          <span>Settings</span>
        </Center>
      ),
      component: <Settings />
    }
  ];

  const currentPage = pageData.find((item) => item.value === dashboardSection);
  return (
    <Stack flex={1} gap={0}>
      <Group p='16' h={80} justify="space-between" bg={colors.lightPurple[0]}>
        <SegmentedControl
          value={currentPage?.value}
          color={colors.lightPurple[5]}
          classNames={{
            root: classes.root,
            label: classes.label
          }}
          data={pageData}
          onChange={handleSegmentChange}
        />
        <Text>
          {String.fromCodePoint(0x1F44B)} Welcome to Ensis, {meData?.first_name}
        </Text>
      </Group>
      {currentPage?.component}
    </Stack >
  );
};

export default Dashboard;
